export const wisereadsCategoriesToDisplayNames = {
  /* eslint-disable @typescript-eslint/naming-convention */
  MOST_HIGHLIGHTED: 'article',
  TWEET_OF_THE_WEEK: 'tweet',
  PDF_OF_THE_WEEK: 'PDF',
  BOOK_OF_THE_WEEK: 'EPUB',
  VIDEO_OF_THE_WEEK: 'video',
 /* eslint-enable @typescript-eslint/naming-convention */
};
